module.exports = __webpack_public_path__ + "assets/img/iarc-5c9262bf.png";